<template>
  <div class="portrait-main">
    <el-popover placement="bottom" :visible-arrow="false">
      <div style="display: -webkit-flex; flex-direction: row" slot="reference">
        <img :src="this.account.headPhoto" class="portrait" />
        <div class="user-name" style="align-self: center">
          {{ account.nickName }}
        </div>
      </div>

      <div class="user-detail">
        <img :src="this.account.headPhoto" class="detail-portrait" />
        <div class="detail-user-name">{{ account.nickName }}</div>
        <div class="detail-user-email">{{ account.email }}</div>
        <div class="detail-line"></div>
        <div class="detail-logout" @click="logout">退出登录</div>
      </div>
    </el-popover>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { delCookie } from "@/utils/CookieUtils";

export default {
  name: "OEMPortrait",
  computed: mapState({
    account(state) {
      return state.account.account;
    },
  }),
  data() {
    return {
      showDetailContent: false,
    };
  },
  methods: {
    showDetail() {},
    logout() {
      delCookie("nickName");
      delCookie("accessToken");
      delCookie("email");
      delCookie("headPhoto");
      this.$router.push({ path: "/login" });
    },
  },
};
</script>

<style lang="less" scoped>
.portrait-main {
  height: 30px;
  margin-top: 11px;
  border-left: 1px solid #ffffff26;
  display: flex;
  align-items: center;
  margin-right: 24px;
  position: relative;
}

.portrait {
  width: 30px;
  height: 30px;
  background-image: url("../../assets/images/ic_n_portrait_s@2x.png");
  background-size: 100%;
  margin-left: 10px;
  margin-right: 10px;
  cursor: pointer;
}

.user-name {
  min-width: 47px;
  height: 22px;
  font-family: PingFangSC-Regular;
  line-height: 22px;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  font-weight: 400;
}

.user-detail {
    // width: 120px;
    // height: 120px;
    // border: 1px solid #e9e9e9;
    // border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.detail-portrait {
  width: 30px;
  height: 30px;
  background-image: url("../../assets/images/ic_n_portrait_s@2x.png");
  background-size: 100%;
}

.detail-user-name {
  height: 16px;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
  text-align: center;
  line-height: 16px;
  font-weight: 400;
  margin-top: 3px;
}

.detail-user-email {
  height: 16px;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.25);
  text-align: center;
  line-height: 16px;
  font-weight: 400;
}

.detail-line {
  width: 100%;
  height: 1px;
  border: 1px solid #e9e9e9;
  margin-top: 10px;
}

.detail-logout {
  height: 20px;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
  text-align: center;
  line-height: 20px;
  font-weight: 400;
  margin-top: 7px;
  cursor: pointer;
}
</style>
